import '../styles/Common.css';
import '../styles/About.css';
import {useTranslation, Trans} from "react-i18next";
import SEO from "./SEO";
import heroBackgroundImage from '../assets/images/hero_background/about_hero_bg_original4.jpg';
import React from "react";

const People = () => {
    const {t, i18n} = useTranslation(['people', 'common', 'title'])
    const isChinese = i18n.language === 'zh';
    const leaders = t('leaders', {ns: 'people', returnObjects: true});
    const core_research_fellows = t('core_research_fellows', {ns: 'people', returnObjects: true});
    return (
        <div className={"bg-white"}>
            <SEO title={t('people', {ns: 'html_title'})}></SEO>
            <div className={"bg-cover bg-white bg-blend-multiply bg-bottom bg-no-repeat min-h-[350px] sm:min-h-[400px] w-full flex flex-col justify-start items-center p-6"}
                 style={{backgroundImage: `url(${heroBackgroundImage})`}}
            >
                <div className={"flex flex-col justify-center items-start max-w-[900px] mt-36 mb-16"}>
                    <div className={`font-bold tracking-[.02em] text-white leading-normal ${isChinese ? 'text-4xl sm:text-[3.5rem] sm:tracking-[.05em]' : 'text-4xl sm:text-[3rem] sm:tracking-[.02em]'}`}>
                        {t('hero_heading_1')}
                    </div>
                </div>
            </div>
            <div className={"content-container py-24"}>
                <div className={"md:w-[70%] lg:max-w-[900px] mx-auto mb-24 px-12"}>
                    <div className={"text-neutral-600 text-xl font-light font-sans leading-loose"}>
                        <p className="">
                            {t('introduction')}
                        </p>
                    </div>
                </div>
                <div className={"flex flex-col justify-center items-center max-w-6xl mx-auto px-6 sm:px-12 pb-36 rounded-3xl bg-cover bg-white bg-blend-multiply bg-center-top bg-no-repeat"}>
                    <div className={"mb-16 text-[#0076d6] font-semibold text-4xl"}>
                        {t('section_heading_1')}
                    </div>
                    {leaders && leaders.map((person, index) => (
                        <div key={index} className="border-b-4 border-[#0076d6] w-full md:w-[600px] lg:w-[800px] mb-16 px-8 py-12 flex flex-col md:flex-row justify-start items-center bg-gray-50 shadow-lg">
                            <img className="mb-4 w-32 h-32 object-cover rounded-full border-2 border-gray-300 md:mr-12"
                                 src={process.env.PUBLIC_URL + `/images/people/${person.image}`} alt={person.name}
                                 style={{objectPosition: 'center top'}}
                            />
                            <div className="flex flex-col items-center sm:items-start">
                                <p className="mb-5 text-[#0076d6] font-semibold text-center sm:text-start">{person.role}</p>
                                <h3 className="text-3xl font-medium text-gray-800 mb-7">{person.name}</h3>
                                <ul className="list-disc list-inside text-gray-600">
                                    {person.titles.map((title, idx) => (
                                        <li key={idx}>{title}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))
                    }
                    <div className={"my-16 text-[#0076d6] font-semibold text-4xl"}>
                        {t('section_heading_2')}
                    </div>
                    {core_research_fellows.map((person, index) => (
                        <div key={index} className="border-b-4 border-[#0076d6] w-full md:w-[600px] lg:w-[800px] mb-16 px-8 py-12 flex flex-col md:flex-row justify-start items-center bg-gray-50 shadow-lg">
                            <img className="mb-4 xl:mb-0 w-32 h-32 object-cover rounded-full border-2 border-gray-300 md:mr-12"
                                 src={process.env.PUBLIC_URL + `/images/people/${person.image}`} alt={person.name}
                                 style={{objectPosition: 'center top'}}
                            />
                            <div className="flex flex-col items-center sm:items-start">
                                <h3 className="text-3xl font-medium text-gray-800 mb-7">{person.name}</h3>
                                <ul className="list-disc list-inside text-gray-600">
                                    {person.titles.map((title, idx) => (
                                        <li key={idx}>{title}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))
                    }
                </div>
            </div>
        </div>
    );
};

export default People;